import { EffectDiagnocoinAdjustmentReasonCode } from 'protocol/api/billing_new/dto_order_new_pb';

import { DiagnocoinAdjustmentReason } from './types';

export const DIAGNOCOIN_ADJUSTMENT_REASONS: DiagnocoinAdjustmentReason[] = [
  EffectDiagnocoinAdjustmentReasonCode.EffectDiagnocoinAdjustmentReasonCode_DiagnocatEmployeeError,
  EffectDiagnocoinAdjustmentReasonCode.EffectDiagnocoinAdjustmentReasonCode_ReactivationByAgreement,
  EffectDiagnocoinAdjustmentReasonCode.EffectDiagnocoinAdjustmentReasonCode_ContractTermination,
  EffectDiagnocoinAdjustmentReasonCode.EffectDiagnocoinAdjustmentReasonCode_ConfigurationTesting,
];
